export const NUMBER_OF_ASSESSMENTS = 8;
export const FIRST_ASSESSMENT_NUMBER = 10001;